export default "__VITE_ASSET__KroU1U0p__"